/**
 * @module tree/rendered
 */

import inserted from './inserted.js'
import aborting from '../utils/aborting.js'
import never from '../utils/never.js'
import promisify from '../utils/promisify.js'

/**
 * Awaits a target rendering & returns true if still into the provided container
 * @param {Node} target The node to be rendered
 * @param {Node} container The future node container
 * @param {?Promise<*>} abort The abortion promise
 * @return {Promise<boolean>}
 */
export default async (target, container, abort = never) => {
  await inserted(target, container)
  
  const { ownerDocument } = container
  const { defaultView } = ownerDocument
  const { requestAnimationFrame } = defaultView
  const animationFrame = promisify(requestAnimationFrame)
  const [aborted, symbol] = aborting(abort)
  const animationFrames = Promise.all([animationFrame(), animationFrame()])
  const result = await Promise.race([animationFrames, aborted])
  
  return result !== symbol && ownerDocument.contains(target)
}
